////////////////////////////////////////////
// BOTTOM NAV — MOBILE ICON TAB BAR (HIDDEN FROM lg UP)
////////////////////////////////////////////
//
// FIXED ICON-ONLY TAB BAR, 3–5 ITEMS (BOTTOM-NAV GUIDANCE): EACH TAB IS A
// FULL-HEIGHT flex-1 TOUCH TARGET (≥54px), LABELS LIVE IN aria-label/title,
// THE ACTIVE TAB GETS THE BLAZE ACCENT + aria-current, AND THE BAR PADS FOR
// THE iOS HOME-INDICATOR SAFE AREA. z-30 SITS BELOW THE TOP NAV'S z-40 SO
// THE WALLET SHEET (RENDERED INSIDE THE TOP NAV) COVERS IT WHILE OPEN.
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { isActiveLink, type NavLinkDef } from "@/app/layout/nav/links";

export function BottomNav({ links, suffix }: { links: NavLinkDef[]; suffix: string }) {

  const { pathname } = useLocation();
  const [search] = useSearchParams();

  return (
    <nav
      aria-label="Primary"
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-bg/94 backdrop-blur-[10px] border-t border-line pb-[env(safe-area-inset-bottom)]"
    >
      <div className="flex items-stretch">
        {links.map((l) => {

          const active = isActiveLink(l, pathname, search);
          return (
            <Link
              key={l.to}
              to={l.to + suffix}
              aria-label={l.label}
              title={l.label}
              aria-current={active ? "page" : undefined}
              className={
                "flex-1 flex items-center justify-center min-h-[54px] transition-colors " +
                (active ? "text-blaze" : "text-dim hover:text-fg active:text-fg")
              }
            >
              <l.Icon className="w-[22px] h-[22px] flex-none" />
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
